module.exports = __webpack_public_path__ + "media/images/advertise/copy_of_eatokra_social_media_templates_15-194a1b3e918352179eb1982b2015b856.png";